module.exports = __webpack_public_path__ + "cycling/static/img/brac_newlogo2.989d8246.png";